module.exports = __webpack_public_path__ + "img/mastercard.68add214.png";